import React from 'react';

type Props = {
    className?          : string
    value               : any
    field               : any      //FieldMultiselect
    disabled?           : boolean

    onChange?           : callback
    onImmediateChange?  : callback
}

export default class FieldMultiselect_FormComponent extends React.Component<Props, any> {

    constructor(props: Props) {
        super(props);

        this.state = {
            currentOptions: props.value,
            showPopover: false,
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                currentOptions: this.props.value
            })
        }
    }

    showPopover = () => {
        if (!this.state.showPopover && !this.props.disabled) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {
        let currentOptions = this.state.currentOptions ? this.state.currentOptions.slice() : [];

        if (!!option.isAllValuesOption) {
            // all values option click
            currentOptions = null;
        } else if (this.props.field.toggleOptionValue) {
            // field-specific toggle - e.g. cascading selection (see FieldProjectAccessMultiselect)
            currentOptions = this.props.field.toggleOptionValue(currentOptions, option.value);
        } else {
            currentOptions = gd.utils.toggleArrayValue(currentOptions, option.value);
        }

        this.setState({
            currentOptions: currentOptions
        }, () => {
            if (this.props.onChange) this.props.onChange(currentOptions);
        });
    }

    render() {
        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const selectedOptions = this.props.field._getOptions(this.state.currentOptions);

        // need check value because of none
        if (!!selectedOptions && selectedOptions.length > 0) {
            return (
                <field.components.FormValueNotEmpty className   = {classes}
                                                    disabled    = {this.props.disabled}
                                                    field       = {field}
                                                    options     = {selectedOptions}
                                                    onClick     = {this.showPopover}
                                                    onDelete    = {this.onOptionClick}>

                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}

                </field.components.FormValueNotEmpty>
            );
        } else {
            return (
                <field.components.FormValueEmpty className  = {classes}
                                                 disabled   = {this.props.disabled}
                                                 field      = {field}
                                                 onClick    = {this.showPopover}>

                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}

                </field.components.FormValueEmpty>
            );
        }
    }
}
